import PropTypes from "prop-types"

import Shimmer from "components/ui/shimmer"
import { cn } from "styles/utils"

import { Container } from "./article-card"

const ArticleCardLoading = ({ featured }) => (
  <Container>
    <Shimmer
      className="pb-(--base-padding-bottom) tablet:pb-(--tablet-padding-bottom) w-full"
      style={{
        "--base-padding-bottom": "65.89%",
        "--tablet-padding-bottom": "40.32%",
      }}
    />
    <div>
      <Shimmer
        className={cn("h-22 mb-10 w-full", featured && "h-30 tablet:mb-24")}
      />
      <Shimmer
        className="h-(--base-height) mb-16 w-full"
        style={{ "--base-height": featured ? "22px" : "66px" }}
      />
      <Shimmer style={{ height: "21px", width: "66px" }} />
    </div>
  </Container>
)

ArticleCardLoading.propTypes = {
  featured: PropTypes.bool,
}

export default ArticleCardLoading
